<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="职业健康管理系统" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目介绍"></main-title>
        <retract-list :dataList="introduceList"></retract-list>
      </div>
    </section>

    <!-- 产品特点 -->
    <section class="d-flex align-items-center pt-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="产品特点"></main-title>
        <div class="indentation pb-4">
          <desc-list :dataList="lightSpotList"></desc-list>
        </div>
        <h1 class="title-main text-align-center font-weight-bold pb-4">职业健康管理系统流程图</h1>
        <img src="@/assets/img/common/ehs/ehs.png"  class="image-width-100 pb-4"/>
        <card-list :dataList="highList"></card-list>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'Ehs',
  components: { Swiper},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/ehs/banner1.png") },
        { src: require("@/assets/img/common/caseList/ehs/banner2.png") },
      ],
      // 项目背景
      projectList: [
        '建立职业健康管理体系的目的是提升工作场所的健康性和安全性，维护员工的合法利益，保护环境。它的推行和实施，对增强公司的凝聚力，完善工厂的内部管理，提升工厂形象，创造更好的经济效益和社会效益能起到极大的推动作用。项目客户为全球顶尖电池制造企业，其蓄电池产品线包括富液式和阀控密封式铅酸蓄电池、镍镉蓄电池、锂电池以及相应的充电设备和电池系统设备。基于电池行业的需要，客户企业很早就成立了EHS部门，但长期以来，用Excel进行数据分析的劣势与日俱增：产出效率低、信息不同步、维护成本高、集中管理难等等。走向信息化，成为了EHS部门的重中之中。基于客户企业的发展规划，该项目的目标是实现EHS职业卫生健康（血铅）电子档案的建设，以人为本，走出EHS迈向信息化的第一步。',
      ],
      // 项目介绍
      introduceList: [
        '职业健康管理系统旨在构建员工职业健康电子档案，并生成各类职业有害因素专项报表。',
        '1.结合员工身份信息和体检数据生成员工健康电子档案。',
        '2.通过员工体检数据生成各类职业有害因素专项报表。',
        '3.针对员工体检历史发送健康通知。'
      ],
      // 产品特点
      lightSpotList: [
        {
          title: "电子档案：",
          titleDetail:"根据上传的体检数据，可生成各员工的健康档案。",
        },
        {
          title: "专项报表：",
          titleDetail: "系统中可自动生成针对全厂、部门、岗位的各类专项报表。",
        },
        {
          title: "健康通知：",
          titleDetail: "针对员工的体检结果，系统可以发出不同种类的通知消息用于引导员工遵循公司的安全管理规范。",
        }
      ],
      highList: [
        {
          src: require("@/assets/img/common/ehs/highlights1.png"),
          smSrc: require("@/assets/img/common/ehs/highlights1-s.png"),
          title: '电子档案-体检数据1'
        },
        {
          src: require("@/assets/img/common/ehs/highlights2.png"),
          smSrc: require("@/assets/img/common/ehs/highlights2-s.png"),
          title: '电子档案-体检数据2'
        },
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>